import Observer from "./observer.js"

class YoutubeAPI extends Observer {
  constructor(){
    super()
    this.API_URL = "https://www.youtube.com/iframe_api?enablejsapi=1"
  }

  data(){
    return {
      "loaded": false
    }
  }

  changed(){
    return {
      "loaded": (val)=>{

      }
    }
  }

  loadAPI(){
    var self = this

    if(this.$data.loaded === true){
      this.displatchEvent("loaded", this.$data.loaded)
      return
    }
    window.onYouTubeIframeAPIReady = onYoutubeIframeAPIReadyHandler
    var scriptElement = document.createElement("script")
    scriptElement.setAttribute("src", this.API_URL)
    document.querySelectorAll("body")[0].appendChild(scriptElement)


    function onYoutubeIframeAPIReadyHandler(){
      self.$data.loaded = true
    }
  }
}

const instance = new YoutubeAPI()
export default instance
